import {PALETTE_IDS} from '#core/application/modules/ids.js';

export function getEventListConfig() {
    const CUSTOM_CONFIG = {};

    return {
        custom: {
            [PALETTE_IDS.EVENT_LIST]: CUSTOM_CONFIG,
        },
    };
}
